import styled from "styled-components";

const Separator = styled.hr.attrs((props) => ({
  strokeWidth: props.strokeWidth || "0",
  color: props.color,
  margin: props.margin || "8px 0",
}))`
  border: ${(props) => props.strokeWidth} inset ${(props) => props.color};
  margin: ${(props) => props.margin};
`;

export default Separator;
